/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { Text } from "vr-react-components";
import React from "react";
import { BackgroundPanel } from "vr-react-components";
import { Button } from "vr-react-components";
import { useDispatch, useSelector } from "react-redux";
import JobLogModal from "./JobLog/JobLogModal";
import { getFormattedTime } from "../utils/TimeUtils";
import { setOpenedModal } from "../store/slice/roomSlices/jobRoomSlice";

const JobTooltip = ({
    element,
    width,
    height,
    textSizeDecimal,
    noJobLog,
    ...otherAttributes
}) => {
    let left = [
        "Job name:",
        "Status:",
        "Type:",
        "Workflow:",
        "Folder:",
        "Job logs output:",
        "Planned Start:",
        "Last definition change:",
    ];
    let right = [
        element.name,
        element.status,
        element.type && element.type.split("$")[0],
        element.workflow,
        element.folder,
        "View",
        getFormattedTime(element.plannedStart) || "Not planned",
        element.lastDefinitionChanges
            ? getFormattedTime(element.lastDefinitionChanges)
            : "Never changed",
    ];

    const jobLog = {
        current: element.currentJobLog,
        previous: element.previous 
    }
    
    const device = useSelector((state) => state.private.device);
    const isJobLogOpened = useSelector((state) => state.jobroom.openedModal);

    const dispatch = useDispatch();
    const generateText = () => {
        const rows = left.length;
        const rowHeight = (height * 0.75) / rows;
        return left.map((e, i) => {
            return (
                <a-entity key={i}>
                    <Text
                        width={width * 0.5}
                        sizeDecimal={textSizeDecimal}
                        text={left[i]}
                        align="left"
                        position={`0 ${-height * 0.2 - i * rowHeight} 0`}
                        baseline="bottom"
                    />
                    {left[i] !== "Job logs output:" ? (
                        <Text
                            width={width * 0.6}
                            sizeDecimal={textSizeDecimal}
                            text={right[i]}
                            align="right"
                            position={`${width * 0.9} ${-height * 0.2 - i * rowHeight} 0`}
                            baseline="bottom"
                        />
                    ) : (
                        <Button
                            type={Button.constants.primary}
                            width={width * 0.25}
                            height={rowHeight * 0.8}
                            textSizeDecimal={textSizeDecimal}
                            aframeClasses={device.canModify ? "collidable" : ""}
                            position={`${width * 0.9 - width * 0.125} ${-height * 0.2 - i * rowHeight + rowHeight * 0.4
                                } ${width / 100}`}
                            text={right[i]}
                            onClickHandler={() => {
                                dispatch(setOpenedModal("jobLog"))
                            }}
                        />
                    )}
                    <a-entity
                        line={`start:${0} ${-height * 0.2 - i * rowHeight} 0;end:${width * 0.9
                            } ${-height * 0.2 - i * rowHeight} 0;color:#c6c6c6;opacity:0.5`}
                    />
                </a-entity>
            );
        });
    };

    return (
        <BackgroundPanel width={width} height={height} opacity={1} {...otherAttributes}>
            <a-entity
                position={`${(-width / 2) * 0.9} ${height / 2 - height / 10} 0.001 `}
            >
                <Text
                    width={width * 0.9}
                    sizeDecimal={textSizeDecimal * 0.8}
                    text={"Job information"}
                    baseline="top"
                />
                {generateText()}
            </a-entity>
            {isJobLogOpened === "jobLog" && !device.inVRMode && <JobLogModal jobLog={jobLog} />}
        </BackgroundPanel>
    );
};

export default JobTooltip;
